// Japanese UI catalog — generated from the English strings used in the JSX (English text is the key).
// Regenerate the key list with scripts/i18n-keys.mjs; keep entries in English order.
export const ja: Record<string, string> = {
  "Active only": "進行中のみ",
  "Attach files": "ファイルを添付",
  "Attach files to the comment; you can also paste or drop them into it": "コメントにファイルを添付します。貼り付けやドロップでも追加できます",
  "Attach files to this task; you can also drop them here": "このタスクにファイルを添付します。ここにドロップすることもできます",
  "Attachments": "添付ファイル",
  "Delete {name}?": "{name} を削除しますか？",
  "Download": "ダウンロード",
  "No files yet. Drop files here or use Attach files.": "まだファイルはありません。ここにドロップするか「ファイルを添付」を使ってください。",
  "No files.": "ファイルはありません。",
  "Remove this file": "このファイルを削除",
  "Show only tasks in progress, hiding the backlog and done. Remembered, and shared by the task views.": "進行中のタスクのみを表示し、バックログと完了を非表示にします。設定は保存され、各タスクビューで共有されます。",
  "Hide tasks that are done. Remembered, and shared by the task views.": "完了したタスクを非表示にします。設定は保存され、各タスクビューで共有されます。",
  "Show backlog": "バックログを表示",
  "Upload failed": "アップロードに失敗しました",
  "Uploading 1 file…": "1 件のファイルをアップロード中…",
  "Uploading {n} files…": "{n} 件のファイルをアップロード中…",
  "With \"Active only\" on, also show tasks still in the backlog. Remembered.": "「進行中のみ」がオンのとき、バックログのタスクも表示します。設定は保存されます。",
  "Markdown · type @ to mention someone · Ctrl-Enter posts": "Markdown · @ を入力してメンバーをメンション · Ctrl-Enter で投稿",
  "Nothing to preview yet.": "プレビューする内容がまだありません。",
  "Show the comment formatted, as it will appear": "投稿後の表示どおりに、書式を適用して表示します",
  "Write": "編集",
  "in a comment": "コメント内",
  "nav.home": "ホーム",
  "nav.time": "時間",
  "nav.timesheets": "タイムシート",
  "nav.leave": "休暇",
  "nav.reports": "レポート",
  "nav.projects": "プロジェクト",
  "nav.people": "メンバー",
  "nav.payroll": "給与",
  "nav.admin": "管理",
  "nav.signout": "サインアウト",
  "nav.portfolios": "ポートフォリオ",
  "1 year": "1年",
  "30 days": "30日",
  "90 days": "90日",
  "A token lets Claude Code (or a script) act as you through the API: projects, portfolios, tasks, schedules, links, milestones and your time. It never reaches rates, budgets, payroll, approvals, admin or account settings, whatever your role.": "トークンを使うと、Claude Code（またはスクリプト）が API を通じてあなたとして操作できます：プロジェクト、ポートフォリオ、タスク、スケジュール、リンク、マイルストーン、あなたの時間。役割にかかわらず、単価、予算、給与、承認、管理、アカウント設定には決して届きません。",
  "Create token": "トークンを作成",
  "Created": "作成日",
  "Dismiss": "閉じる",
  "Read tokens can only look; write tokens can also create and change tasks, links, milestones and time entries. Everything a token does is audited as you, marked with the token's name.": "読み取りトークンは閲覧のみ、書き込みトークンはタスク、リンク、マイルストーン、時間エントリの作成と変更もできます。トークンの操作はすべてあなたとして監査され、トークン名が記録されます。",
  "Read: look only. Write: create and change tasks, links, milestones and time": "読み取り：閲覧のみ。書き込み：タスク、リンク、マイルストーン、時間の作成と変更",
  "Revoke": "無効化",
  "Revoked:": "無効化済み：",
  "Scope": "範囲",
  "The token is shown once, when you create it. Revoke it here if it leaks.": "トークンは作成時に一度だけ表示されます。漏えいした場合はここで無効化してください。",
  "Then start Claude Code and ask it, for example, \"what is overdue across my portfolio?\" or \"plan the importer epic in DEN with four tasks and link them\".": "その後 Claude Code を起動し、例えば「ポートフォリオ全体で期限超過は？」や「DEN のインポーター エピックを4つのタスクで計画して関連付けて」と頼んでください。",
  "To use it from Claude Code, put it in your shell and add the server once:": "Claude Code から使うには、シェルに設定してサーバーを一度追加してください：",
  "Token": "トークン",
  "Token name, e.g. Claude Code on my laptop": "トークン名（例：ノートPCの Claude Code）",
  "When the token stops working on its own": "トークンが自動的に失効する時期",
  "created. Copy it now — it will not be shown again.": "を作成しました。今すぐコピーしてください。再表示されません。",
  "for Claude Code and scripts": "Claude Code とスクリプト向け",
  "login.title": "サインイン",
  "never expires": "無期限",
  "read and write": "読み取りと書き込み",
  "read only": "読み取り専用",
  "via API token": "API トークン経由",
  "login.email": "メール",
  "login.password": "パスワード",
  "login.button": "サインイン",
  "login.google": "Google で続行",
  "login.passkey": "パスキーでサインイン",
  "login.or": "またはパスワードを使用",
  "common.save": "保存",
  "common.cancel": "キャンセル",
  "common.delete": "削除",
  "common.edit": "編集",
  "common.add": "追加",
  "common.loading": "読み込み中…",
  "time.start": "タイマー開始",
  "time.stop": "停止して保存",
  "time.thisWeek": "今週",
  "offline.queued": "{n} 件の時間エントリが送信待ちです — オンラインに戻ると送信されます",
  "offline.queuedPlural": "{n} 件の時間エントリが送信待ちです — オンラインに戻ると送信されます",
  "+ Add": "+ 追加",
  "+ Task": "+ タスク",
  "+ sub": "+ サブ",
  "1 person notified": "1 名に通知しました",
  "1 private project hidden": "非公開プロジェクト 1 件を非表示",
  "1 private project is hidden from these totals.": "非公開プロジェクト 1 件はこれらの合計に含まれていません。",
  "1 project": "1 プロジェクト",
  "1. Scan the code with your authenticator app, or enter this key manually:": "1. 認証アプリでコードをスキャンするか、このキーを手動で入力してください：",
  "13 weeks": "13週間",
  "2. Enter the 6-digit code the app shows to confirm.": "2. アプリに表示される6桁のコードを入力して確認します。",
  "26 weeks": "26週間",
  "4 weeks": "4週間",
  "8 weeks": "8週間",
  "A flag is a named on/off switch you control here without a deploy. Every signed-in browser receives the current flags, and features can check them to show or hide something.": "フラグは、デプロイなしでここから制御できる名前付きのオン/オフスイッチです。サインイン中のすべてのブラウザーが現在のフラグを受け取り、機能はそれを見て何かを表示/非表示にできます。",
  "A person is": "該当者は",
  "A portfolio groups related projects under one initiative (a client, a programme, a department) with a shared board, list and Gantt.": "ポートフォリオは関連するプロジェクトを1つの取り組み（顧客、プログラム、部門など）にまとめ、共有のボード・リスト・ガントを提供します。",
  "A portfolio groups related projects under one initiative (a client, a programme, a department).": "ポートフォリオは関連するプロジェクトを1つの取り組み（顧客、プログラム、部門など）にまとめます。",
  "A private project appears only in your own project list — no one else can see it, whatever their role": "非公開プロジェクトは自分のプロジェクト一覧にのみ表示されます — ロールにかかわらず、他の誰にも見えません",
  "A simple sub-task with its own key; it appears here, not on the board": "独自のキーを持つ簡単なサブタスク。ここに表示され、ボードには表示されません",
  "A token acts as this person through the API: projects, portfolios, tasks, schedules and their time, never rates, payroll or admin. Everything it does is audited as them, marked with the token's name, and your name is recorded as the one who issued it.": "トークンは API を通じてこの人として操作します：プロジェクト、ポートフォリオ、タスク、スケジュール、その人の時間。単価、給与、管理には決して届きません。行った操作はすべてその人として、トークン名付きで監査に残り、発行者としてあなたの名前も記録されます。",
  "API tokens": "API トークン",
  "Account": "アカウント",
  "Accounts are invite-only. If you have an invite link, open it to set up your account.": "アカウントは招待制です。招待リンクをお持ちなら、開いてアカウントを設定してください。",
  "Action": "操作",
  "Actions": "操作",
  "Add": "追加",
  "Add a comment": "コメントを追加",
  "Add a milestone on this day": "この日にマイルストーンを追加",
  "Add a person": "メンバーを追加",
  "Add a person…": "メンバーを追加…",
  "Add a status column (columns are the project's statuses)": "ステータス列を追加（列はプロジェクトのステータスです）",
  "Add a subtask under this task": "このタスクの下にサブタスクを追加",
  "Add a task due on this day": "この日が期限のタスクを追加",
  "Add a task in this column": "この列にタスクを追加",
  "Add a top-level task": "トップレベルのタスクを追加",
  "Add checklist item": "チェックリスト項目を追加",
  "Add column": "列を追加",
  "Add entry": "エントリを追加",
  "Add holiday": "休日を追加",
  "Add project…": "プロジェクトを追加…",
  "Add rate": "レートを追加",
  "Add subtask": "サブタスクを追加",
  "Add task": "タスクを追加",
  "Add the column at the end; drag its header to reorder": "末尾に列を追加します。ヘッダーをドラッグして並べ替え",
  "Add the item": "項目を追加",
  "Added": "追加済み",
  "Address / CIDR": "アドレス / CIDR",
  "Addresses on file (restriction currently off):": "登録済みアドレス（現在制限はオフ）：",
  "Adds a second step to password sign-in: a 6-digit code from an app such as Google Authenticator, 1Password or Authy.": "パスワードサインインに第2ステップを追加します：Google Authenticator、1Password、Authy などのアプリの6桁コード。",
  "Admin console": "管理コンソール",
  "After": "以後",
  "Alert at %": "% でアラート",
  "All portfolios you can see; create one there": "閲覧できるすべてのポートフォリオ。作成もそこから",
  "All projects": "すべてのプロジェクト",
  "All states": "すべての状態",
  "Amount": "金額",
  "An account for an integration, left out of payroll, timesheets and scheduled reports": "連携用のアカウント。給与、タイムシート、スケジュール済みレポートからは外れます",
  "An invite lets them pick their own password. Creating an account here sends no email at all: it exists straight away, and you decide whether it has a password.": "招待ではパスワードを本人が決めます。ここでアカウントを作るとメールは一切送られず、すぐにアカウントができ、パスワードを付けるかどうかはあなたが決めます。",
  "Analytics": "分析",
  "Any action": "すべての操作",
  "Any milestone": "すべてのマイルストーン",
  "Any priority": "すべての優先度",
  "Any project": "すべてのプロジェクト",
  "Any status": "すべてのステータス",
  "Anyone": "誰でも",
  "Approvals": "承認",
  "Approve although it was not submitted — you'll be warned if the week is empty or thin, and the person is notified": "未提出のまま承認 — 週が空または少ない場合は警告され、本人に通知されます",
  "Approve without submission?": "未提出のまま承認しますか？",
  "Approve — locks the week; any later work must be a correction entry": "承認 — 週をロックします。以後の作業は修正エントリとして記録します",
  "Approve — reduces their available capacity for those days": "承認 — 該当日の稼働可能時間が減ります",
  "Approved": "承認済み",
  "Archive": "アーカイブ",
  "Archive this portfolio? Its projects are unchanged; the portfolio drops out of the default lists.": "このポートフォリオをアーカイブしますか？プロジェクトは変わりません。ポートフォリオは既定の一覧から外れます。",
  "Assign to…": "担当者を設定…",
  "Assignee": "担当者",
  "At a glance": "概要",
  "At least 12 characters. A password found in a public breach is refused.": "12 文字以上。公開された漏えいに含まれるパスワードは拒否されます。",
  "At least 12 characters. A short sentence works well.": "12文字以上。短い文がおすすめです。",
  "Auto-schedule": "自動スケジュール",
  "Avatar URL": "アバターの URL",
  "Awaiting approval": "承認待ち",
  "Awaiting your approval": "あなたの承認待ち",
  "Back": "戻る",
  "Back to portfolios": "ポートフォリオ一覧へ戻る",
  "Back to projects": "プロジェクト一覧へ戻る",
  "Baseline": "ベースライン",
  "Before": "以前",
  "Bill rates": "請求レート",
  "Billable + non": "請求対象 + 対象外",
  "Billable only": "請求対象のみ",
  "Billable value": "請求額",
  "Board": "ボード",
  "Breadcrumb": "パンくず",
  "Budget": "予算",
  "Bulk-load people, projects, and an opening task backlog from CSV files.": "CSV ファイルから人・プロジェクト・初期タスクバックログを一括読み込みします。",
  "Burndown / burnup": "バーンダウン / バーンアップ",
  "Calendar": "カレンダー",
  "Calendar settings": "カレンダー設定",
  "Cancel": "キャンセル",
  "Cancel this pending invite": "この保留中の招待を取り消す",
  "Cancel this request (or approved leave that hasn't started)": "この申請（またはまだ開始していない承認済み休暇）を取り消す",
  "Capacity": "キャパシティ",
  "Category": "カテゴリ",
  "Change any field on this person's record, including their email": "メールアドレスを含め、この人の登録内容のどの項目も変更します",
  "Change password": "パスワードを変更",
  "Change the email for {name} to {email}? That address is where password resets go, and they are told about the change.": "{name} のメールアドレスを {email} に変更しますか？パスワード再設定はこのアドレスに届き、本人にも変更が通知されます。",
  "Changes save as you edit; this confirms and closes the editor": "変更は編集中に保存されます。これで確定してエディターを閉じます",
  "Checking invite…": "招待を確認中…",
  "Checking…": "確認中…",
  "Choose the timezone carefully — it cannot be changed afterwards.": "タイムゾーンは慎重に選んでください — 後から変更できません。",
  "Clear": "クリア",
  "Click": "クリック",
  "Click the": "クリック：",
  "Close": "閉じる",
  "Code": "コード",
  "Collapse": "折りたたむ",
  "Collapse this card": "このカードを折りたたむ",
  "Collapse this section (remembered for you)": "このセクションを折りたたむ（あなた用に記憶）",
  "Colour": "色",
  "Owner": "担当者",
  "Colour the task bars by owner (assignee). Remembered.": "タスクバーを担当者ごとに色分けします。設定は保存されます。",
  "Colour for this calendar's events": "このカレンダーの予定の色",
  "Column (status) name shown on the board": "ボードに表示される列（ステータス）名",
  "Column name": "列名",
  "Command": "コマンド",
  "Command palette": "コマンドパレット",
  "Comment": "コメント",
  "Comment deleted": "コメントは削除されました",
  "Comment deleted by {name}": "{name} がコメントを削除しました",
  "Comments": "コメント",
  "Commit": "確定",
  "Company holidays": "会社の休日",
  "Completed": "完了",
  "Confirm new password": "新しいパスワード（確認）",
  "Confirm password": "パスワード（確認）",
  "Connect Google Calendar": "Google カレンダーを接続",
  "Connecting failed. Try again.": "接続に失敗しました。もう一度お試しください。",
  "Continue with Google": "Google で続行",
  "Copied": "コピーしました",
  "Copy all": "すべてコピー",
  "Copy link": "リンクをコピー",
  "Copy password": "パスワードをコピー",
  "Copy the claude mcp add command": "claude mcp add コマンドをコピーします",
  "Copy the export line": "export の行をコピーします",
  "Copy the password so you can pass it on": "パスワードをコピーして本人に渡せるようにします",
  "Copy the token": "トークンをコピーします",
  "Correct…": "修正…",
  "Cost rate": "コストレート",
  "Cost rates": "コストレート",
  "Could not create portfolio": "ポートフォリオを作成できませんでした",
  "Could not load the overview.": "概要を読み込めませんでした。",
  "Create a one-time invite link (7 days) and email it if mail is configured": "使い捨ての招待リンク（7日間）を作成し、メール設定があればメール送信",
  "Create a project — you'll choose its permanent timezone-of-truth": "プロジェクトを作成 — 恒久的な基準タイムゾーンを選びます",
  "Create a task scheduled today for one week; drag its bar to adjust": "今日から1週間のタスクを作成。バーをドラッグして調整",
  "Create a top-level task in this project; open it afterwards to set dates, assignee, estimate": "このプロジェクトにトップレベルタスクを作成。あとで開いて日付・担当者・見積を設定",
  "Create account": "アカウントを作成",
  "Create feed link": "フィードリンクを作成",
  "Create invite": "招待を作成",
  "Create one below, then file projects under it from a project's": "下で作成し、その後プロジェクトの",
  "Create one from the Portfolios page, then file projects under it from a project's": "ポートフォリオページで作成し、その後は各プロジェクトの次の画面からプロジェクトを登録します：",
  "Create project": "プロジェクトを作成",
  "Create the account now — nobody is emailed": "今すぐアカウントを作成します。メールは誰にも送りません",
  "Create the task": "タスクを作成",
  "Create the task in this column": "この列にタスクを作成",
  "Create your personal feed link": "個人フィードリンクを作成",
  "Cumulative flow": "累積フロー",
  "Cumulative flow, cycle time, burndown, velocity, forecast": "累積フロー、サイクルタイム、バーンダウン、ベロシティ、予測",
  "Currency": "通貨",
  "Current password": "現在のパスワード",
  "Cycle (d)": "サイクル（日）",
  "Dashboard, projects, members, settings": "ダッシュボード、プロジェクト、メンバー、設定",
  "Dashboard, tasks, members, milestones, settings": "ダッシュボード、タスク、メンバー、マイルストーン、設定",
  "Date": "日付",
  "Dates": "日程",
  "Dates in": "日程の基準",
  "Day": "日",
  "Deactivate your account (history is kept); you will be asked to confirm": "アカウントを無効化（履歴は保持）。確認を求められます",
  "Decides whether this account can sign in the moment you create it": "作成した時点でこのアカウントがサインインできるかどうかを決めます",
  "Decline with a reason; the person is notified": "理由を添えて却下。本人に通知されます",
  "Delete": "削除",
  "Delete column": "列を削除",
  "Delete milestone": "マイルストーンを削除",
  "Delete task": "タスクを削除",
  "Delete this column (only when empty)": "この列を削除（空の場合のみ）",
  "Delete this comment? Its replies stay.": "このコメントを削除しますか？返信はそのまま残ります。",
  "Delete this milestone": "このマイルストーンを削除",
  "Delete this task": "このタスクを削除",
  "Delete this task (and its subtasks); logged time is kept": "このタスク（とサブタスク）を削除。記録済みの時間は保持されます",
  "Resize the task list": "タスク一覧のサイズを変更",
  "Drag to resize the task list; double-click to reset": "ドラッグしてタスク一覧の幅を変更します。ダブルクリックで元に戻します",
  "Delete this task and its subtasks; logged time is kept": "このタスクとサブタスクを削除。記録済みの時間は保持されます",
  "Description": "説明",
  "Directory": "ディレクトリ",
  "Discard": "破棄",
  "Discuss this milestone": "このマイルストーンについて話し合う",
  "Discussion": "ディスカッション",
  "Display only — never changes which week an entry belongs to.": "表示専用 — エントリの所属週は変わりません。",
  "Does not match.": "一致しません。",
  "Done": "完了",
  "Download CSV": "CSV をダウンロード",
  "Download a JSON file with everything stored about you": "あなたに関する保存データすべてを JSON ファイルでダウンロード",
  "Download as a PDF table": "PDF 表としてダウンロード",
  "Download as an Excel workbook": "Excel ブックとしてダウンロード",
  "Download everything stored about you — profile, memberships, time entries, tasks assigned, leave, approvals, notifications — as JSON.": "あなたに関する保存データすべて — プロフィール、所属、時間エントリ、担当タスク、休暇、承認、通知 — を JSON でダウンロードします。",
  "Download my data": "自分のデータをダウンロード",
  "Download partial CSV": "部分 CSV をダウンロード",
  "Download these rows as CSV": "これらの行を CSV でダウンロード",
  "Drag cards, or focus a card and press": "カードをドラッグするか、カードにフォーカスして押す：",
  "Drag to change priority; Space + arrows works from the keyboard": "ドラッグで優先順位を変更。キーボードでは Space + 矢印キー",
  "Drag to move between columns or reorder; Space + arrows works from the keyboard": "ドラッグで列間移動や並べ替え。キーボードなら Space + 矢印",
  "Drop idle time — save up to the idle moment, then restart": "アイドル時間を除外 — アイドル開始時点まで保存して再開",
  "Due": "期限",
  "Each status maps to a global category (to do / in progress / done / archived) so reporting works across projects. Keep at least one per category. Archived work is left out of every count and hidden unless asked for.": "各ステータスはグローバルカテゴリ（未着手 / 進行中 / 完了 / アーカイブ）に対応し、プロジェクト横断のレポートが機能します。各カテゴリに最低1つ残してください。アーカイブした作業はすべての集計から除外され、指定しない限り表示されません。",
  "Archived": "アーカイブ",
  "Also show tasks in an archived status. Remembered, and shared by the task views and the board.": "アーカイブ状態のタスクも表示します。設定は保存され、各タスクビューとボードで共有されます。",
  "Waterfall": "ウォーターフォール",
  "Lay linked tasks out left to right: any task that overlaps what its links allow moves later (keeping its length), then rows are ordered by start, linked ones in link order. Done and archived tasks stay put. Saved; press again after changes.": "リンクされたタスクを左から右へ並べます。リンクの制約と重なるタスクは期間を保ったまま後ろへ移動し、行は開始日順（リンクされたものはリンク順）に並べ替えます。完了・アーカイブ済みのタスクは動きません。保存されます。変更後は再度押してください。",
  "Waterfall:": "ウォーターフォール：",
  "rescheduled": "件を再スケジュール",
  "reordered": "件を並べ替え",
  "Already a waterfall: nothing to change": "すでにウォーターフォールです：変更はありません",
  "Could not reschedule the tasks": "タスクを再スケジュールできませんでした",
  "Auto-schedule:": "自動スケジュール：",
  "Already scheduled: nothing to change": "すでにスケジュール済みです：変更はありません",
  "Auto-schedule replans every open task: in-progress work first, then linked tasks as soon as their links allow and others from today, so nobody gets two tasks at once. Continue?": "自動スケジュールは未完了のすべてのタスクを再計画します。進行中の作業を先に、次にリンクされたタスクをリンクが許す最も早い日に、その他を今日から配置し、同時に2つのタスクを担当する人はいなくなります。続行しますか？",
  "Plan the open tasks as soon as possible: linked ones right after their links allow, unlinked past or undated ones from today (undated take their estimate at 8h a day, or 5 days), future unlinked ones keep their start. Each person's tasks are queued, in-progress first and then by priority, so they never overlap, counting their other projects. Done and archived tasks stay put. Saved.": "未完了のタスクをできるだけ早く計画します。リンクされたものはリンクが許す直後に、リンクのない過去または日付なしのものは今日から（日付なしは見積りを1日8時間で換算、なければ5日）、リンクのない未来のものは開始日を維持します。各担当者のタスクは進行中を先に、次に優先度順に並べ、他のプロジェクトも含めて重ならないようにします。完了・アーカイブ済みのタスクは動きません。保存されます。",
  "working days": "営業日",
  "estimated": "時間（見積り）",
  "Edit": "編集",
  "Edit person": "メンバーを編集",
  "Edit your comment; the previous text is kept as history": "コメントを編集します。編集前の本文は履歴として残ります",
  "Elapsed": "経過",
  "Email": "メール",
  "End this session and return to the sign-in page (other devices stay signed in)": "このセッションを終了してサインインページへ戻る（他のデバイスはサインインしたまま）",
  "Ends": "終了",
  "Enter the 6-digit code from your authenticator app, or one of your recovery codes.": "認証アプリの6桁コード、またはリカバリーコードのいずれかを入力してください。",
  "Epic": "エピック",
  "Est.": "見積",
  "Estimate (h)": "見積（h）",
  "Every project-week approved": "すべてのプロジェクト週が承認済み",
  "Everyone": "全員",
  "Everyone (admin)": "全員（管理者）",
  "Everyone in the range is approved — download the payroll CSV": "期間内の全員が承認済み — 給与 CSV をダウンロード",
  "Everything on this person's record. Changes are audit-logged against your name.": "この人の登録内容のすべて。変更はあなたの名前で監査ログに残ります。",
  "Examples:": "例：",
  "Excludes people who still have unapproved weeks; they are named in the file header": "未承認の週が残っている人は除外され、ファイルヘッダーに名前が記載されます",
  "Expand": "展開",
  "Expand this card to see details": "このカードを展開して詳細を見る",
  "Expand this section (remembered for you)": "このセクションを展開（あなた用に記憶）",
  "Expires": "有効期限",
  "External calendars (in)": "外部カレンダー（受信）",
  "Feature flags": "機能フラグ",
  "Field": "項目",
  "Filter the list by project code or name": "プロジェクトコードまたは名前で一覧を絞り込む",
  "Final step: deactivate the account now": "最終ステップ：今すぐアカウントを無効化",
  "For an integration such as Claude Code rather than a colleague: it stays out of payroll, timesheets and scheduled reports.": "同僚ではなく Claude Code のような連携用です。給与、タイムシート、スケジュール済みレポートからは外れます。",
  "Format": "形式",
  "From": "開始",
  "From your calendar today": "今日のカレンダーから",
  "Gantt": "ガント",
  "Global category this column maps to, so cross-project reports keep working": "この列が対応するグローバルカテゴリ。プロジェクト横断レポートが機能し続けます",
  "Google did not grant offline access — remove ADKOM PM under your Google account’s third-party access, then connect again.": "Google がオフラインアクセスを許可しませんでした — Google アカウントのサードパーティアクセスから ADKOM PM を削除して、再接続してください。",
  "Grant read-only access; today's meetings become one-click time entry suggestions": "読み取り専用アクセスを許可。今日の会議がワンクリックの時間入力候補になります",
  "Group by": "グループ化",
  "Group the board into rows by assignee, epic or priority": "担当者・エピック・優先度でボードを行にグループ化",
  "Has unapproved weeks": "未承認の週あり",
  "Hidden projects are a personal view preference; nothing about the project changes": "非表示プロジェクトは個人の表示設定です。プロジェクト自体は変わりません",
  "Hide subtasks": "サブタスクを隠す",
  "Hide this milestone's discussion": "このマイルストーンのディスカッションを隠す",
  "Hide this project from your lists (just for you; the project is unchanged)": "このプロジェクトを自分の一覧から隠す（自分だけ。プロジェクトは変わりません）",
  "Hide this project's tasks": "このプロジェクトのタスクを隠す",
  "Hours": "時間",
  "Hours (30d)": "時間（30日）",
  "Hours for other members are visible to project administrators and managers.": "他メンバーの時間はプロジェクト管理者とマネージャーに表示されます。",
  "Hours per week": "週あたりの時間",
  "Hours/wk": "時間/週",
  "How much of their time the schedule may plan for.": "スケジュールが計画に使える時間の量です。",
  "IP allowlist set by an administrator": "管理者が設定した IP 許可リスト",
  "Identifies this project's tasks on portfolio boards and Gantts": "ポートフォリオのボードやガントでこのプロジェクトのタスクを識別します",
  "Import": "インポート",
  "Import in order: people → projects → tasks.": "順番：人 → プロジェクト → タスク。",
  "In progress": "進行中",
  "Include accounts used by integrations, which are hidden by default": "既定では隠れている連携用アカウントも表示します",
  "Invite": "招待",
  "Invite colleagues and manage roles.": "同僚を招待し、ロールを管理します。",
  "Invite for": "招待先",
  "Issue a token for this person and show it once": "この人のトークンを発行し、一度だけ表示します",
  "Issue or revoke tokens that act as this person through the API": "API でこの人として動くトークンを発行または無効化します",
  "Issues assigned to this GitHub user become tasks assigned to them.": "この GitHub ユーザーに割り当てられた Issue は、この人に割り当てられたタスクになります。",
  "Job title": "役職",
  "Jump to the current week": "今週へ移動",
  "Jump to the top of the page": "ページの先頭へ",
  "Jump to top": "先頭へ",
  "Kanban board across every project in the portfolio": "ポートフォリオ内の全プロジェクトを横断するカンバンボード",
  "Kanban board: drag cards between status columns": "カンバンボード：カードをステータス列間でドラッグ",
  "Keep": "保持",
  "Keep the account": "アカウントを残す",
  "Keep — count the idle time as work": "保持 — アイドル時間を作業として数える",
  "Keeps this account out of payroll, timesheets and scheduled reports.": "このアカウントを給与、タイムシート、スケジュール済みレポートから外します。",
  "Key": "キー",
  "Kind": "種類",
  "Label": "ラベル",
  "Language": "言語",
  "Last": "最終",
  "Last active": "最終アクティブ",
  "Last run": "最終実行",
  "Last sign-in": "最終サインイン",
  "Last used": "最終使用",
  "Lead (d)": "リード（日）",
  "Leave": "休暇",
  "Leave it empty to follow the organisation's working week.": "空のままにすると組織の稼働日数に従います。",
  "Line": "行",
  "List": "リスト",
  "Loading…": "読み込み中…",
  "Log time →": "時間を記録 →",
  "Logged": "記録済み",
  "Managed by": "管理者：",
  "Manager": "マネージャー",
  "Median cycle time": "サイクルタイム中央値",
  "Median lead time": "リードタイム中央値",
  "Member": "メンバー",
  "Members": "メンバー",
  "Mention someone": "メンバーをメンションする",
  "Milestone": "マイルストーン",
  "Milestones": "マイルストーン",
  "Milestone…": "マイルストーン…",
  "Mine open": "自分の未完了",
  "Month": "月",
  "Month view of due dates, milestones and external calendars": "期限・マイルストーン・外部カレンダーの月表示",
  "More actions for this row": "この行のその他の操作",
  "Move this status up one place": "このステータスを1つ上へ",
  "Move up": "上へ",
  "Moving a project out of a portfolio is refused while it has cross-project links": "プロジェクト間リンクがある間は、プロジェクトをポートフォリオから外せません",
  "My private projects": "自分の非公開プロジェクト",
  "My reports": "自分のレポート",
  "My requests": "自分の申請",
  "My tasks": "自分のタスク",
  "Name": "名前",
  "New milestone": "新しいマイルストーン",
  "New password": "新しいパスワード",
  "New portfolio": "新しいポートフォリオ",
  "New portfolio name": "新しいポートフォリオ名",
  "New project": "新しいプロジェクト",
  "New status": "新しいステータス",
  "New subtask": "新しいサブタスク",
  "New task": "新しいタスク",
  "New task in": "新しいタスク：",
  "New task title": "新しいタスクのタイトル",
  "New timer": "新しいタイマー",
  "Next milestone": "次のマイルストーン",
  "Next month": "翌月",
  "Next run": "次回実行",
  "Next week": "翌週",
  "No comments yet.": "まだコメントはありません。",
  "No completed work in the window yet.": "この期間に完了した作業はまだありません。",
  "No cost rate yet.": "コストレートはまだありません。",
  "No data.": "データなし。",
  "No earlier versions.": "以前のバージョンはありません。",
  "No feed link yet.": "フィードリンクはまだありません。",
  "No hours budget set.": "時間予算は未設定です。",
  "No members yet.": "メンバーはまだいません。",
  "No milestones yet.": "マイルストーンはまだありません。",
  "No money budget set.": "金額予算は未設定です。",
  "No open milestones with a due date.": "期限付きの未完了マイルストーンはありません。",
  "No portfolios yet.": "ポートフォリオはまだありません。",
  "No projects filed here yet.": "登録されたプロジェクトはまだありません。",
  "No projects in this portfolio yet.": "このポートフォリオにプロジェクトはまだありません。",
  "No projects match.": "一致するプロジェクトはありません。",
  "No projects yet.": "プロジェクトはまだありません。",
  "No projects.": "プロジェクトはありません。",
  "No tasks yet.": "タスクはまだありません。",
  "No tasks.": "タスクはありません。",
  "No time in this range.": "この範囲に時間はありません。",
  "No time in this window.": "この期間に時間はありません。",
  "No time matches.": "一致する時間はありません。",
  "No tokens yet.": "まだトークンはありません。",
  "Non-billable only": "請求対象外のみ",
  "None": "なし",
  "None yet.": "まだありません。",
  "Not available — approvals are for project administrators.": "利用不可 — 承認はプロジェクト管理者向けです。",
  "Not configured on this server.": "このサーバーでは未設定です。",
  "Not enough history yet for a trend — the weekly chart appears after two weeks of entries.": "トレンド表示にはまだ履歴が足りません — 週次グラフは2週間分のエントリで表示されます。",
  "Not enough history yet for trends and forecasts — they firm up after a couple of weeks of tasks moving. What is here is exact, just short.": "トレンドと予測にはまだ履歴が足りません — タスクが動き出して数週間で安定します。ここにあるものは正確ですが短いだけです。",
  "Not enough history yet — the chart appears once two project weeks have entries.": "まだ履歴が足りません — 2つのプロジェクト週にエントリが入るとグラフが表示されます。",
  "Not submitted": "未提出",
  "Note": "メモ",
  "Note (optional)": "メモ（任意）",
  "Note saved onto the entry": "エントリに保存されるメモ",
  "Note saved onto the time entry when you stop": "停止時に時間エントリへ保存されるメモ",
  "Notes": "メモ",
  "Nothing assigned to you.": "あなたへの割り当てはありません。",
  "Nothing completed yet.": "完了したものはまだありません。",
  "Nothing here.": "ここには何もありません。",
  "Nothing logged yet.": "記録はまだありません。",
  "Nothing recorded yet.": "記録はまだありません。",
  "Nothing yet.": "まだありません。",
  "Notifications": "通知",
  "Now click the task that must wait for": "次に、待つ側のタスクをクリック：",
  "On enter": "開始時",
  "One submission per project per week, in each project's own timezone.": "プロジェクトごと・週ごとに1回の提出。各プロジェクトのタイムゾーン基準です。",
  "Only ephemeral records are ever purged. Business history — time entries, approvals, tasks, the audit log, status transitions — is never touched.": "消去されるのは一時的なレコードのみです。業務履歴 — 時間エントリ、承認、タスク、監査ログ、ステータス遷移 — には一切触れません。",
  "Only you can see these. Drag to prioritize.": "これらはあなたにしか見えません。ドラッグで優先順位を付けます。",
  "Open People": "メンバーを開く",
  "Open People: directory, roles, invites": "メンバーを開く：ディレクトリ、ロール、招待",
  "Open Projects": "プロジェクトを開く",
  "Open Reports to slice logged time": "レポートを開いて記録時間を分析",
  "Open portfolio →": "ポートフォリオを開く →",
  "Open tasks": "未完了タスク",
  "Open the Gantt chart": "ガントチャートを開く",
  "Open the Kanban board": "カンバンボードを開く",
  "Open the Time page: edit timers, notes, tasks": "時間ページを開く：タイマー、メモ、タスクを編集",
  "Open the portfolio": "ポートフォリオを開く",
  "Open the portfolio: shared board, list and Gantt across its projects": "ポートフォリオを開く：プロジェクト横断の共有ボード・リスト・ガント",
  "Open the project": "プロジェクトを開く",
  "Open the task": "タスクを開く",
  "Outstanding": "未処理",
  "Overdue": "期限超過",
  "Overview": "概要",
  "Parent": "親",
  "Password": "パスワード",
  "Paste CSV here…": "ここに CSV を貼り付け…",
  "Pause": "一時停止",
  "Pause this timer; time is kept": "このタイマーを一時停止。時間は保持されます",
  "Pause; time is kept": "一時停止。時間は保持されます",
  "Payroll export": "給与エクスポート",
  "Pending": "保留中",
  "People": "メンバー",
  "Per-project feeds:": "プロジェクト別フィード：",
  "Permanent. Create a new project to use a different zone.": "恒久的です。別のゾーンを使うには新しいプロジェクトを作成してください。",
  "Person": "担当者",
  "Person…": "担当者…",
  "Pick the range by": "範囲の基準：",
  "Portfolio": "ポートフォリオ",
  "Portfolio manager": "ポートフォリオマネージャー",
  "Portfolio not found, or you do not have access.": "ポートフォリオが見つからないか、アクセス権がありません。",
  "Portfolio role": "ポートフォリオロール",
  "Portfolio roles grant access to the merged views; task edits still follow each project's own membership.": "ポートフォリオロールは統合ビューへのアクセスを付与します。タスクの編集は引き続き各プロジェクトのメンバーシップに従います。",
  "Portfolios": "ポートフォリオ",
  "Portfolios don't affect approvals — they add a shared board, list and Gantt, and cross-project links.": "ポートフォリオは承認に影響しません — 共有のボード・リスト・ガントと、プロジェクト間リンクを追加するものです。",
  "Portfolios don't affect permissions or approvals — they are purely for organising and reporting.": "ポートフォリオは権限や承認に影響しません — 整理とレポートのためだけのものです。",
  "Portfolios →": "ポートフォリオ →",
  "Post the comment": "コメントを投稿",
  "Post the comment (Ctrl-Enter)": "コメントを投稿（Ctrl-Enter）",
  "Prev": "前",
  "Preview": "プレビュー",
  "Previous month": "前月",
  "Previous week": "前週",
  "Priority": "優先度",
  "Priority…": "優先度…",
  "Private projects filed here that only their owners can see": "ここに登録された非公開プロジェクト。所有者にしか見えません",
  "Private — only you can see this project": "非公開 — このプロジェクトはあなたにしか見えません",
  "Private — only you will see this project": "非公開 — このプロジェクトはあなたにしか表示されません",
  "Progress": "進捗",
  "Project": "プロジェクト",
  "Project colour": "プロジェクトの色",
  "Project not found, or you do not have access.": "プロジェクトが見つからないか、アクセス権がありません。",
  "Project not found.": "プロジェクトが見つかりません。",
  "Project role": "プロジェクトロール",
  "Project the new task belongs to": "新しいタスクの所属プロジェクト",
  "Projected finish": "予測完了",
  "Projects": "プロジェクト",
  "Projects not yet in a portfolio that you may update": "まだポートフォリオに入っていない、更新可能なプロジェクト",
  "Projects you are a member of.": "あなたがメンバーのプロジェクト。",
  "Projects you can see. Managers and admins see all.": "閲覧できるプロジェクト。マネージャーと管理者はすべて見られます。",
  "Purge immediately using the currently saved policy (not unsaved edits) and record the counts above": "現在保存されているポリシー（未保存の編集ではなく）で今すぐ消去し、件数を上に記録",
  "Push successors when a task moves": "タスク移動時に後続タスクをずらす",
  "Range": "範囲",
  "Rates are visible to managers and administrators.": "レートはマネージャーと管理者に表示されます。",
  "Read this first.": "最初にお読みください。",
  "Read-only: today’s meetings appear as one-click suggestions on the Time page. Your entries flow back to any calendar through the": "読み取り専用：今日の会議が時間ページにワンクリック候補として表示されます。あなたのエントリは次の経路で任意のカレンダーへ戻ります：",
  "Ready": "準備完了",
  "Recently completed": "最近完了",
  "Regenerate": "再生成",
  "Regenerate link": "リンクを再生成",
  "Regenerate recovery codes": "リカバリーコードを再生成",
  "Regenerate the secret link (old link stops working)": "秘密リンクを再生成（古いリンクは無効になります）",
  "Remove": "削除",
  "Remove item": "項目を削除",
  "Remove this calendar": "このカレンダーを削除",
  "Remove this checklist item": "このチェックリスト項目を削除",
  "Remove this comment; its replies stay": "このコメントを削除します。返信は残ります",
  "Repeats": "繰り返し",
  "Reply": "返信",
  "Reply in this thread": "このスレッドに返信する",
  "Report name": "レポート名",
  "Reports": "レポート",
  "Request": "申請",
  "Request failed": "リクエストに失敗しました",
  "Request leave": "休暇を申請",
  "Reset your password": "パスワードをリセット",
  "Result": "結果",
  "Resume": "再開",
  "Resume (pauses the running timer)": "再開（実行中のタイマーを一時停止）",
  "Resume this timer (pauses the running one)": "このタイマーを再開（実行中のものを一時停止）",
  "Retake baseline": "ベースラインを取り直す",
  "Retention": "保持期間",
  "Return the week with a note; the person edits and resubmits": "メモを添えて週を差し戻し。本人が編集して再提出します",
  "Revoke the token \"{name}\"? Anything using it stops working immediately.": "トークン「{name}」を無効化しますか？これを使っているものはすべて直ちに動かなくなります。",
  "Role": "ロール",
  "Run this report automatically on the chosen cadence and deliver it by email/notification": "選んだ頻度でこのレポートを自動実行し、メール/通知で届けます",
  "Save": "保存",
  "Save every change on this record": "この登録内容の変更をすべて保存します",
  "Save policy": "ポリシーを保存",
  "Save policy stores the numbers for the nightly run. Run now purges immediately with the saved policy.": "「ポリシーを保存」は夜間実行用の数値を保存します。「今すぐ実行」は保存済みポリシーで直ちに消去します。",
  "Save the current grouping and filters under a name": "現在のグループ化とフィルターに名前を付けて保存",
  "Save these recovery codes now.": "今すぐこれらのリカバリーコードを保存してください。",
  "Saved reports…": "保存済みレポート…",
  "Saved ✓": "保存しました ✓",
  "Saved.": "保存しました。",
  "Schedule": "スケジュール",
  "Schedule end": "スケジュール終了",
  "Schedule settings per project": "プロジェクトごとのスケジュール設定",
  "Scheduled reports": "スケジュール済みレポート",
  "Scroll the timeline back to today": "タイムラインを今日へ戻す",
  "Search": "検索",
  "Search code or name…": "コードまたは名前で検索…",
  "Search…": "検索…",
  "Send the request to your line manager (some types are approved automatically)": "上長へ申請を送信（一部の種類は自動承認）",
  "Send them a password reset link from the directory when they are ready to sign in.": "サインインできるようにするときは、ディレクトリからパスワード再設定リンクを送ってください。",
  "Send them this link — it is shown once and expires in 7 days:": "このリンクを送ってください — 1度だけ表示され、7日で失効します：",
  "Send this project-week to the project administrator for approval; you can withdraw until they decide": "このプロジェクト週をプロジェクト管理者へ承認申請。決定まで取り下げ可能",
  "Sent back": "差し戻し",
  "Service account": "サービスアカウント",
  "Set a new password for": "新しいパスワードを設定：",
  "Set a password": "パスワードを設定",
  "Set status…": "ステータスを設定…",
  "Set the task and a note when you start, or edit them in the list.": "開始時にタスクとメモを設定するか、一覧で編集してください。",
  "Set up your account": "アカウントを設定",
  "Settings": "設定",
  "Share with project": "プロジェクトと共有",
  "Show": "表示",
  "Show archived": "アーカイブ済みを表示",
  "Show failed sign-in attempts": "失敗したサインイン試行を表示",
  "Show service accounts": "サービスアカウントを表示",
  "Show sign-in attempts": "サインイン試行を表示",
  "Show subtasks": "サブタスクを表示",
  "Show the audit log": "監査ログを表示",
  "Show this project in your lists again": "このプロジェクトを一覧に再表示",
  "Show this project's tasks": "このプロジェクトのタスクを表示",
  "Show what this comment said before it was edited": "編集前のコメント内容を表示する",
  "Shows their day in the right hours; it never changes which week an entry belongs to.": "その人の一日を正しい時刻で表示します。エントリの所属週は変わりません。",
  "Sign in": "サインイン",
  "Sign in with your device's fingerprint, face or PIN, or a hardware key — no password or code needed. Passkeys are phishing-resistant.": "デバイスの指紋・顔・PIN、またはハードウェアキーでサインイン — パスワードもコードも不要。パスキーはフィッシング耐性があります。",
  "Sign out": "サインアウト",
  "Signed in": "サインイン済み",
  "Signing in…": "サインイン中…",
  "Since": "開始",
  "Sortable table of tasks across every project in the portfolio": "ポートフォリオ内の全プロジェクトのタスクを並べ替え可能な表で表示",
  "Sortable table of tasks with bulk edit and saved views": "一括編集と保存ビュー付きの並べ替え可能なタスク表",
  "Start (or switch) your timer for this project onto this task; any running timer pauses": "このプロジェクトのタイマーをこのタスクで開始（または切替）。実行中のタイマーは一時停止",
  "Start a timer for this project (pauses any running timer)": "このプロジェクトのタイマーを開始（実行中のタイマーは一時停止）",
  "Start timer": "タイマー開始",
  "Start timer on this task": "このタスクでタイマー開始",
  "Starts": "開始",
  "State": "状態",
  "Status": "ステータス",
  "Stop and save": "停止して保存",
  "Stop and save one time entry for the total": "停止し、合計で1件の時間エントリを保存",
  "Stop and save one time entry for the total on this project": "停止し、このプロジェクトの合計で1件の時間エントリを保存",
  "Stop anything using this token, immediately": "このトークンを使っているものを直ちに止めます",
  "Stop at idle — save up to the idle moment and stop": "アイドル時点で停止 — アイドル開始時点まで保存して停止",
  "Stop reading your Google Calendar": "Google カレンダーの読み取りを停止",
  "Stop the timer running on this task and save one time entry": "このタスクで実行中のタイマーを停止して時間エントリを保存",
  "Stop timer": "タイマー停止",
  "Store these numbers as the policy; the nightly purge uses them from its next run": "これらの数値をポリシーとして保存。夜間消去は次回実行から使用します",
  "Subscribe": "購読",
  "Subscribe your calendar app to this link to see your tasks (due dates), leave, your projects' milestones and your last 90 days of time entries.": "このリンクをカレンダーアプリで購読すると、タスク（期限）、休暇、プロジェクトのマイルストーン、直近90日の時間エントリを表示できます。",
  "Subscribe your calendar app to your tasks, leave, milestones and recent time entries.": "カレンダーアプリでタスク・休暇・マイルストーン・最近の時間エントリを購読。",
  "Swimlanes": "スイムレーン",
  "System state, the audit trail, and sign-in activity. People and invites are under": "システム状態、監査証跡、サインイン活動。メンバーと招待は次の場所：",
  "Take baseline": "ベースラインを取得",
  "Take the project out of this portfolio (the project itself is unchanged)": "このポートフォリオからプロジェクトを外す（プロジェクト自体は変わりません）",
  "Take the submission back to edit the week; resubmit when ready": "提出を取り下げて週を編集。準備できたら再提出",
  "Task": "タスク",
  "Task (optional)": "タスク（任意）",
  "Task this timer is for (optional)": "このタイマーの対象タスク（任意）",
  "Task title": "タスクのタイトル",
  "Tasks": "タスク",
  "Tasks can't move between projects": "タスクはプロジェクト間で移動できません",
  "Tasks live inside projects; open Projects": "タスクはプロジェクト内にあります。プロジェクトを開いてください",
  "Team (last 30 days)": "チーム（直近30日）",
  "That does not look like a valid zone.": "有効なゾーンではないようです。",
  "The calendar's public iCal URL": "カレンダーの公開 iCal URL",
  "The link is a secret — anyone holding it can read your feed. Regenerate it if it leaks.": "このリンクは秘密です — 持っている人は誰でもフィードを読めます。漏れたら再生成してください。",
  "The numbers below are the": "下の数値は",
  "The person accountable for the portfolio; always a portfolio administrator": "ポートフォリオの責任者。常にポートフォリオ管理者です",
  "There is no password yet, so nobody can sign in as them. Issue a password reset link from the directory when they are ready.": "まだパスワードがないため、この人としてサインインすることはできません。準備ができたら、ディレクトリからパスワード再設定リンクを発行してください。",
  "They can sign in with the password you set.": "設定したパスワードでサインインできます。",
  "This account can only be used from these addresses (set by an administrator):": "このアカウントは次のアドレスからのみ使用できます（管理者が設定）：",
  "This browser does not support passkeys.": "このブラウザーはパスキーに対応していません。",
  "This invite is invalid or has expired. Ask an administrator for a new one.": "この招待は無効か期限切れです。管理者に新しいものを依頼してください。",
  "This password is shown once and will not be shown again. Give it to them over a channel you trust; they can change it under Account.": "このパスワードは一度だけ表示され、二度と表示されません。信頼できる方法で本人に渡してください。本人はアカウントで変更できます。",
  "Throw this timer away without saving": "このタイマーを保存せずに破棄",
  "Time": "時間",
  "Time is approved per project, per week, in each project's own timezone.": "時間はプロジェクトごと・週ごとに、各プロジェクトのタイムゾーンで承認されます。",
  "Time off is approved by your line manager and reduces your available capacity for that week — it never counts as hours worked.": "休暇は上長が承認し、その週の稼働可能時間を減らします — 労働時間には決して数えられません。",
  "Timeline across projects: cross-project links, critical path": "プロジェクト横断のタイムライン：プロジェクト間リンク、クリティカルパス",
  "Timeline: drag bars, link dependencies, critical path, baseline": "タイムライン：バーをドラッグ、依存関係をリンク、クリティカルパス、ベースライン",
  "Timesheets": "タイムシート",
  "Timezone": "タイムゾーン",
  "Timezone of truth": "基準タイムゾーン",
  "Title": "タイトル",
  "Title of the new task; you can fill in the rest from the task editor": "新しいタスクのタイトル。残りはタスクエディターで入力できます",
  "To": "終了",
  "To confirm, type your name exactly:": "確認のため、名前を正確に入力してください：",
  "To connect Claude Code as this account, put the token in the shell and add the server once:": "このアカウントとして Claude Code を接続するには、トークンをシェルに設定し、サーバーを一度追加します：",
  "To do": "未着手",
  "Token name, e.g. Claude Code": "トークン名（例：Claude Code）",
  "Top": "先頭",
  "Total": "合計",
  "Turn off": "オフにする",
  "Turn off authenticator": "認証アプリをオフにする",
  "Turn on": "オンにする",
  "Type": "種類",
  "Type @ to mention someone · Ctrl-Enter posts": "@ を入力してメンバーをメンション · Ctrl-Enter で投稿",
  "Type a command, project, task key, or name…  (Ctrl-K toggles)": "コマンド、プロジェクト、タスクキー、名前を入力…（Ctrl-K で切替）",
  "Type your display name exactly to enable the final button": "最終ボタンを有効にするには表示名を正確に入力",
  "Unarchive": "アーカイブ解除",
  "Unassigned": "未割り当て",
  "Unlock an approved week for edits; requires a reason, recorded in the audit log, and notifies the person": "承認済みの週を編集用にロック解除。理由が必要で、監査ログに記録され、本人に通知されます",
  "Unshare": "共有解除",
  "Upcoming milestones": "今後のマイルストーン",
  "Update password": "パスワードを更新",
  "Upload": "アップロード",
  "Use them to try a change with a few people first, or to switch a feature off quickly if it misbehaves.": "まず少人数で変更を試したり、問題があれば機能をすばやくオフにしたりするのに使います。",
  "Velocity": "ベロシティ",
  "Velocity (estimate hours done per week)": "ベロシティ（週あたり完了見積時間）",
  "Velocity per week": "週あたりベロシティ",
  "Verify": "確認",
  "Views…": "ビュー…",
  "WIP limit": "WIP 上限",
  "Week": "週",
  "Week of": "週：",
  "Weeks awaiting submission": "提出待ちの週",
  "Weeks from": "開始週",
  "Weeks run Monday→Monday in": "週は月曜→月曜。基準：",
  "What": "内容",
  "What did you work on?": "何に取り組みましたか？",
  "What they see the app in until they choose otherwise.": "本人が別の言語を選ぶまで、アプリはこの言語で表示されます。",
  "What this person costs per hour (effective-dated); click to view history or change it": "この人の1時間あたりコスト（発効日付き）。クリックで履歴の確認や変更",
  "When": "日時",
  "When done, the next occurrence is created with dates shifted.": "完了すると、日付をずらした次回分が作成されます。",
  "Where password resets go. Change it and they are emailed about it.": "パスワード再設定の届き先です。変更すると本人にメールで通知されます。",
  "Which project the new timer is for": "新しいタイマーの対象プロジェクト",
  "Who": "誰",
  "Working days per week": "週の稼働日数",
  "Write a comment…": "コメントを入力…",
  "Write a reply…": "返信を入力…",
  "You are not a member of any project yet, so there is nowhere to log time. Ask a project administrator to add you.": "まだどのプロジェクトのメンバーでもないため、時間を記録する場所がありません。プロジェクト管理者に追加を依頼してください。",
  "You become its portfolio manager; add projects and members from the portfolio page, or file a project from its": "あなたがポートフォリオマネージャーになります。ポートフォリオページからプロジェクトとメンバーを追加するか、各プロジェクトの次の画面から登録します：",
  "You can also send them the link directly:": "リンクを直接送ることもできます：",
  "You can see this project's tasks here but not change them": "このプロジェクトのタスクはここで閲覧できますが、変更はできません",
  "You do not have access to this page.": "このページへのアクセス権がありません。",
  "You have been invited as": "次のロールで招待されました：",
  "You have no line manager set, so requests will wait for an administrator. Ask an admin to set your manager under People.": "上長が未設定のため、申請は管理者待ちになります。管理者にメンバーページで上長の設定を依頼してください。",
  "You need edit rights in both projects to link them": "リンクするには両方のプロジェクトで編集権限が必要です",
  "You sign in with Google, which handles two-factor authentication for you. These options apply to password sign-in.": "Google でサインインしているため、二要素認証は Google が処理します。これらのオプションはパスワードサインイン向けです。",
  "You sign in with Google. A password gives you a fallback if Google is unavailable.": "Google でサインインしています。パスワードがあれば Google が使えないときの予備になります。",
  "Your colleagues.": "同僚。",
  "Your feed (out)": "あなたのフィード（送信）",
  "Your name": "あなたの名前",
  "Your own zone, for display. Projects keep their own timezone-of-truth.": "表示用のあなたのゾーン。プロジェクトは独自の基準タイムゾーンを保持します。",
  "Your role": "あなたのロール",
  "Your role requires a second factor for password sign-in. Set up an": "あなたのロールではパスワードサインインに第2要素が必要です。次を設定：",
  "Your week is shown in": "週の表示基準：",
  "Zoom": "ズーム",
  "active people": "有効なメンバー",
  "active projects": "有効なプロジェクト",
  "approvals arrive in Phase 3": "承認はフェーズ3で登場",
  "archived": "アーカイブ済み",
  "assignee: clear": "担当者：クリア",
  "assignee: keep": "担当者：維持",
  "audit trail for this project": "このプロジェクトの監査証跡",
  "billable hours": "請求対象時間",
  "billed amount": "請求額",
  "by": "：",
  "change in Settings": "設定で変更",
  "closes Monday": "月曜に締切",
  "comments and @mentions about the project as a whole": "プロジェクト全体についてのコメントと @メンション",
  "correction": "修正",
  "cost": "コスト",
  "cost / hour": "コスト / 時",
  "created": "作成",
  "created → done": "作成 → 完了",
  "critical tasks": "クリティカルタスク",
  "current": "現在",
  "current + new + confirm": "現在 + 新規 + 確認",
  "current 6-digit code": "現在の6桁コード",
  "days": "日",
  "deleted": "削除済み",
  "description, dashboard": "説明、ダッシュボード",
  "devices signed in as you": "あなたとしてサインイン中のデバイス",
  "done": "完了",
  "download everything stored about you": "あなたに関する保存データすべてをダウンロード",
  "due +days": "期限 +日",
  "edited": "編集済み",
  "edited by": "編集者:",
  "est. h": "見積 h",
  "estimate hours": "見積時間",
  "every 2 weeks": "2週ごと",
  "every day": "毎日",
  "every month": "毎月",
  "every quarter": "四半期ごと",
  "every week": "毎週",
  "extra recipients (comma-separated)": "追加の宛先（カンマ区切り）",
  "failed sign-ins (24h)": "失敗したサインイン（24h）",
  "feed URL, Google Calendar, external calendars": "フィード URL、Google カレンダー、外部カレンダー",
  "fingerprint, face, security key": "指紋、顔、セキュリティキー",
  "from": "開始",
  "generate one and show it to me once": "生成して一度だけ表示する",
  "hidden": "非表示",
  "hours": "時間",
  "hours and money caps, alerts": "時間と金額の上限、アラート",
  "hours logged": "記録時間",
  "hours logged (yours where restricted)": "記録時間（制限がある場合は自分の分のみ）",
  "iCal subscription link": "iCal 購読リンク",
  "in": "所属：",
  "in progress": "進行中",
  "kept": "保持",
  "last 30 days": "直近30日",
  "last month": "先月",
  "last week": "先週",
  "latest scheduled finish across projects": "全プロジェクト中で最も遅いスケジュール上の終了日",
  "list view, editor, checklists": "リスト表示、エディター、チェックリスト",
  "live sessions": "ライブセッション",
  "logged this week": "今週の記録",
  "median cycle time (days)": "サイクルタイム中央値（日）",
  "median lead time (days)": "リードタイム中央値（日）",
  "migrations": "マイグレーション",
  "month to date": "月初から今日まで",
  "name, dates, timezone, archive": "名前、日程、タイムゾーン、アーカイブ",
  "name, description, portfolio manager, archive": "名前、説明、ポートフォリオマネージャー、アーカイブ",
  "name, language, timezone": "名前、言語、タイムゾーン",
  "navigate · Enter run · Esc close": "移動 · Enter 実行 · Esc 閉じる",
  "never": "なし",
  "no estimates yet": "見積はまだありません",
  "no rate — billable time counts as unrated": "レートなし — 請求対象時間はレート未設定として集計",
  "no scheduled tasks yet": "スケジュール済みタスクはまだありません",
  "non-billable": "請求対象外",
  "none yet": "まだなし",
  "none — portfolio views assign a palette colour": "なし — ポートフォリオビューではパレットの色が割り当てられます",
  "none — they cannot sign in yet": "なし — まだサインインできません",
  "now has an account.": "のアカウントができました。",
  "off": "オフ",
  "office, home…": "オフィス、自宅…",
  "on": "オン",
  "open tasks assigned to me": "自分に割り当てられた未完了タスク",
  "or set a password": "またはパスワードを設定",
  "or use a password": "またはパスワードを使用",
  "overdue": "期限超過",
  "overdue ·": "期限超過 ·",
  "payroll-ready": "給与処理可",
  "people are": "名は",
  "permanent — read first": "名は",
  "person is": "恒久的 — 先にお読みください",
  "person's zone": "本人のゾーン",
  "policy": "ポリシー",
  "portfolio": "ポートフォリオ",
  "portfolio administrator": "ポートフォリオ管理者",
  "portfolio end": "ポートフォリオ終了",
  "predecessor": "先行タスク",
  "priority: keep": "優先度：維持",
  "private": "非公開",
  "project administrator": "プロジェクト管理者",
  "project zone": "プロジェクトのゾーン",
  "projected finish": "予測完了",
  "projects": "プロジェクト",
  "rate / hour": "レート / 時",
  "read this once": "一度お読みください",
  "read-only": "読み取り専用",
  "rejected — resubmit": "却下 — 再提出",
  "service account": "サービスアカウント",
  "set one now": "今すぐ設定する",
  "subtask": "サブタスク",
  "synced": "同期済み",
  "system": "システム",
  "taken": "取得日",
  "task count": "タスク数",
  "tasks": "タスク",
  "tasks done": "完了タスク",
  "then": "次に",
  "this device": "このデバイス",
  "this week": "今週",
  "throughput": "スループット",
  "time entries": "時間エントリ",
  "time-based codes (TOTP)": "時間ベースのコード（TOTP）",
  "to": "終了",
  "to do": "未着手",
  "two-way sync": "双方向同期",
  "unassigned": "未割り当て",
  "updated": "更新",
  "velocity (h / week)": "ベロシティ（h / 週）",
  "week start": "週の開始",
  "weeks awaiting submission": "提出待ちの週",
  "workflow columns and transitions": "ワークフローの列と遷移",
  "your hours logged": "あなたの記録時間",
  "your password": "あなたのパスワード",
  "zero slack: a delay moves the end date": "余裕ゼロ：遅れると終了日が動きます",
  "{n} people notified": "{n} 名に通知しました",
  "{n} private projects are hidden from these totals.": "{n} 件の非公開プロジェクトはこの集計から除外されています。",
  "{n} private projects hidden": "{n} 件の非公開プロジェクトが非表示",
  "{n} projects": "{n} 件のプロジェクト",
  "— (top level)": "—（トップレベル）",
  "— no task —": "— タスクなし —",
  "— none —": "— なし —",
  "— unassigned —": "— 未割り当て —",
  "🔒 approved": "🔒 承認済み",
  "Task completed.": "タスクを完了しました。",
  "Task reopened.": "タスクを再開しました。",
  "Applies immediately to this browser and every device you sign in on; overrides the browser language.": "このブラウザーとサインインするすべてのデバイスに即時適用され、ブラウザーの言語設定より優先されます。",
  "A confirmation link was sent to the new address (valid 2 days). Your email changes when you open it.": "確認リンクを新しいアドレスに送信しました（2日間有効）。開くとメールアドレスが変わります。",
  "Cancel it": "取り消す",
  "Change email": "メールアドレスを変更",
  "Change now": "今すぐ変更",
  "Change now (with password)": "今すぐ変更（パスワードで）",
  "Change the email immediately": "メールアドレスを直ちに変更",
  "Changed. Use the new address next time you sign in.": "変更しました。次回のサインインから新しいアドレスを使ってください。",
  "Confirm email": "メールアドレスの確認",
  "Done — your sign-in email is now": "完了 — サインイン用メールアドレスは次になりました：",
  "Either way the old address is told, and the change is recorded in the audit log.": "いずれの場合も旧アドレスに通知され、変更は監査ログに記録されます。",
  "Mail is not configured on this server, so open this link yourself (valid 2 days):": "このサーバーではメールが設定されていないため、このリンクをご自身で開いてください（2日間有効）：",
  "New email": "新しいメールアドレス",
  "Send a confirmation link to the new address": "新しいアドレスに確認リンクを送信",
  "Send confirmation link": "確認リンクを送信",
  "This account signs in with Google, so its email is managed by Google and cannot be changed here.": "このアカウントは Google でサインインするため、メールアドレスは Google が管理しており、ここでは変更できません。",
  "Verify first": "先に確認",
  "Verify first (send a link)": "先に確認（リンクを送信）",
  "Waiting for confirmation of": "確認待ち：",
  "Your email is what you sign in with and where notifications are mailed.": "メールアドレスはサインインに使われ、通知の送信先でもあります。",
  "a link is sent to the new address; the change happens when you open it, so a typo can't lock you out.": "新しいアドレスにリンクが送られ、開いたときに変更されるため、入力ミスで締め出されることはありません。",
  "enter your current password and the address changes immediately.": "現在のパスワードを入力すると、アドレスが直ちに変わります。",
  "expires": "期限",
  "A status update is waiting to be sent to GitHub": "ステータス更新が GitHub への送信待ちです",
  "API calls left this hour": "今時間の残り API 呼び出し",
  "Assign to matching people": "一致する担当者に割り当てる",
  "Close and reopen issues when task status changes": "タスクのステータス変更時に Issue を閉じる／再開する",
  "Connect": "接続",
  "Connect a repository to import its issues as tasks. When a task is finished here, the issue is closed on GitHub; when an issue is closed or reopened on GitHub, the task follows.": "リポジトリを接続すると Issue をタスクとして取り込めます。ここでタスクを完了すると GitHub の Issue が閉じられ、GitHub で Issue を閉じたり再開したりするとタスクも追従します。",
  "Connected to": "接続先:",
  "Could not load the GitHub connection.": "GitHub 接続を読み込めませんでした。",
  "Create missing milestones": "存在しないマイルストーンを作成する",
  "Disconnect": "接続解除",
  "Disconnect this repository? Existing issue links are kept; nothing is deleted on GitHub.": "このリポジトリの接続を解除しますか？既存の Issue リンクは保持され、GitHub 上では何も削除されません。",
  "Fine-grained personal access token": "Fine-grained パーソナルアクセストークン",
  "GITHUB_WEBHOOK_SECRET is not set on the server, so changes made on GitHub reach APM by hourly polling or “Sync now” rather than instantly.": "サーバーに GITHUB_WEBHOOK_SECRET が設定されていないため、GitHub 側の変更は即時ではなく 1 時間ごとのポーリングまたは「今すぐ同期」で APM に反映されます。",
  "GitHub": "GitHub",
  "GitHub username": "GitHub ユーザー名",
  "GitHub → Settings → Developer settings → Fine-grained tokens. Limit it to this repository with permission Issues: Read and write (Metadata is included automatically). The token is verified now, stored encrypted, and never shown again.": "GitHub → Settings → Developer settings → Fine-grained tokens。このリポジトリに限定し、権限 Issues: Read and write を付与します（Metadata は自動で含まれます）。トークンは今すぐ検証され、暗号化して保存され、二度と表示されません。",
  "Import issues": "Issue を取り込む",
  "Import issues…": "Issue を取り込む…",
  "Importing…": "取り込み中…",
  "Issue closed as completed →": "完了として閉じられた Issue →",
  "Issue closed as not planned →": "対応しないとして閉じられた Issue →",
  "Issue reopened →": "再開された Issue →",
  "Issues assigned to this GitHub user become tasks assigned to you when a project imports them.": "この GitHub ユーザーに割り当てられた Issue は、プロジェクトが取り込むとあなたに割り当てられたタスクになります。",
  "Labels": "ラベル",
  "Mirror the task status as an apm:… label": "タスクのステータスを apm:… ラベルとして反映する",
  "Moving a task into this status closes the issue as “not planned”; any other done status closes it as “completed”.": "タスクをこのステータスに移すと Issue は「対応しない」として閉じられ、その他の完了ステータスでは「完了」として閉じられます。",
  "No APM account has this GitHub username": "この GitHub ユーザー名を持つ APM アカウントはありません",
  "No issues match.": "一致する Issue はありません。",
  "Priority from labels": "ラベルから優先度",
  "Replace the token or test the connection to resume.": "再開するにはトークンを置き換えるか接続をテストしてください。",
  "Replace token": "トークンを置き換える",
  "Repository": "リポジトリ",
  "Status mapping": "ステータスの対応付け",
  "Sync history": "同期履歴",
  "Sync is paused:": "同期は一時停止中:",
  "Sync now": "今すぐ同期",
  "Synced:": "同期済み:",
  "Syncing…": "同期中…",
  "Test connection": "接続をテスト",
  "Webhook: add": "Webhook: ",
  "When an imported issue carries one of these labels, the task gets the matching priority (first match wins).": "取り込んだ Issue にこれらのラベルがあると、タスクに対応する優先度が付きます（最初に一致したものが優先）。",
  "all": "すべて",
  "already linked": "リンク済み",
  "attempt": "試行",
  "checked": "確認",
  "closed": "クローズ",
  "create": "作成",
  "errors": "エラー",
  "failed": "失敗",
  "first done status": "最初の完了ステータス",
  "first to-do status": "最初の未着手ステータス",
  "import issues as tasks, sync status": "Issue をタスクとして取り込み、ステータスを同期",
  "label, e.g. bug": "ラベル（例: bug）",
  "labels, comma-separated": "ラベル（カンマ区切り）",
  "last checked": "最終確認",
  "linked issues": "リンク済み Issue",
  "next": "次へ",
  "not planned": "対応しない",
  "nothing to do": "変更なし",
  "open": "オープン",
  "open issues": "オープンな Issue",
  "page": "ページ",
  "previous": "前へ",
  "remove": "削除",
  "running": "実行中",
  "same as completed": "完了と同じ",
  "search title or #number": "タイトルまたは #番号で検索",
  "sent to GitHub": "GitHub に送信",
  "to the repository with the server's GITHUB_WEBHOOK_SECRET, content type JSON, events: Issues, Pushes, Pull requests. Without it, changes still arrive by hourly polling or “Sync now”.": "をサーバーの GITHUB_WEBHOOK_SECRET と共にリポジトリに追加してください（コンテンツタイプ JSON、イベント: Issues, Pushes, Pull requests）。未設定でも 1 時間ごとのポーリングや「今すぐ同期」で変更は反映されます。",
  "token": "トークン",
  "update": "更新",
  "update pending": "更新待ち",
  "updated here": "こちらで更新",
  "updates waiting": "更新待ち",
  "Open menu": "メニューを開く",
  "Close menu": "メニューを閉じる",
  "Main menu": "メインメニュー",
  "Management": "管理",
}
